class HomepageController extends PageController {
	
	constructor(){
		super();
		
		this.initOfficeHoursTables();
		this.matchElementHeight();
		
    }
	
	
	matchElementHeight(){
		// match height of office hours table with contact box
		$('.office-item .office-hours table, .office-item .contact.box').matchHeight();
	}
	
	
	initOfficeHoursTables(){
		let tables = $('.office-item .office-hours table');
		
		// clean cells
		let cells = $('td', tables);
		this.cleanEmptyTableCells(cells);
		
		// clean markup added by editor
		$('tbody, thead, tr, th, td', tables).removeAttr('style');
		
		// init responsive reflow tables
		tables.addClass('tablesaw tablesaw-stack');
		tables.attr('data-tablesaw-mode','stack');
		//tables.attr('data-tablesaw-hide-empty','');
		Tablesaw.init();
	}
	
	
	/*
	 * Remove whitespace from table cells that have no text
	 */
	cleanEmptyTableCells(cells){
		cells.each((index, element) => {
			let cell = $(element);
			if(cell.text().trim() === ''){
				cell.text('');
			}
		});		
	}


	initMaps(){
		$('.map-container').each((index, element) => {
			let item = $(element);
			this.initMap(item);
		});		
	}


	initMap(mapContainer){
		if(mapContainer.length === 1){
			let title = mapContainer.data('title');
			let address = mapContainer.data('address');
			let gpsLat = parseFloat(mapContainer.data('gpsLat'));
			let gpsLng = parseFloat(mapContainer.data('gpsLng'));
			let mapUrl = mapContainer.data('mapUrl');
			let markerImageUrl = mapContainer.data('markerImage');
			let markerImageSize = { width: 47, height: 64 };

			let pos = {lat: gpsLat, lng: gpsLng };
			let map = new google.maps.Map(mapContainer[0], {
				center: pos,
				zoom: 16,
				scrollwheel: false,
				signInControl: false
			});

			let contentString = '<div class="map-info-window-content">';
			contentString += '<h3>' + title + '</h3>';
			contentString += '<p>' + address + '</p>';
			if(mapUrl.length > 7) {
				contentString += '<p><a href="' + mapUrl + '" target="_blank">Zvětšit mapu</a></p>';
			}
			contentString += '</div>';

			let infowindow = new google.maps.InfoWindow({
				content: contentString,
				//pixelOffset: new google.maps.Size(-(markerImageSize.width/2),0)
			});

			let image = {
				url: markerImageUrl,
				size: new google.maps.Size(markerImageSize.width, markerImageSize.height),
				scaledSize: new google.maps.Size(markerImageSize.width, markerImageSize.height),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(markerImageSize.height/2, markerImageSize.height)
			};

			let marker = (new google.maps.Marker({
				position: pos,
				map: map,
				title: title,
				icon: image
			}));

			marker.addListener('click', function () {
				infowindow.open(map, marker);
			});
		}
	}
	
}
